import cx from 'classnames';
import {
    BUY_IN_ESHOP,
    BUY_IN_MK_ESHOP,
    IN_MK_ESHOP,
    SHOPPING_WITH_MK,
} from 'mk/autogenerated/translations/EshopProductWidget.929bef723a28295bdcf2a922d101cb63'
import assetUrl from 'mk/common/assetUrl';
import { ESHOP_URL } from 'mk/settings';
import { common_api_redirect_to_eshop_url } from 'mk/urls/functions';
import { EshopProductEntity } from 'mk2/apps/blogs/schemas';
import { moneyPretty } from 'mk2/apps/bo/utils';
import styles from 'mk2/apps/groups/containers/EshopProducts/EshopProduct.mscss';
import { Btn, BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { Clamp } from 'mk2/components/Clamp';
import { Img } from 'mk2/components/Img';
import { ImgCropped, ImgCropMode } from 'mk2/components/ImgCropped';
import { Link } from 'mk2/components/Link';
import { getDomain } from 'mk2/helpers/urls';
import React from 'react';

export enum EshopProductWidgetSlot {
    GROUP_FEED_HEADER = 'group_feed_header',
    GROUP_FEED_POSTS = 'group_feed_posts',
    GROUP_FEED_FOOTER = 'group_feed_footer',

    FORUM_THREAD_HEADER = 'forum_thread_header',
    FORUM_THREAD_POSTS = 'forum_thread_posts',
    FORUM_THREAD_FOOTER = 'forum_thread_footer',

    COUNSELLING_FOOTER = 'counselling_footer',

    WIKI_ARTICLE = 'wiki_article',
    BAZAAR_GRID = 'bazaar_grid',
}

interface OwnProps {
    eshopProducts: EshopProductEntity[];
    slot: EshopProductWidgetSlot;
    pageId: number;
    widgetPosition: number;
    small: boolean;
    header: boolean;
}

type Props = OwnProps;

export default class EshopProductWidget extends React.PureComponent<Props> {

    public render() {
        const { eshopProducts, slot, pageId, widgetPosition, small, header } = this.props;

        if (!eshopProducts) {
            return null;
        }

        const avatarSize = small ? 24 : 36;
        const style = small ? 'small' : 'big';
        const headerText = small ? getDomain(ESHOP_URL) : SHOPPING_WITH_MK;

        return (
            <div
                className={cx(
                            styles.EshopProductWidget,
                            styles[`EshopProductWidget__${style}`],
                )}>
                {header &&
                    <>
                        <div
                            className={styles[`EshopProductWidget__container${style}`]}
                        >
                            <Img
                                className={styles.EshopProductWidget__containerImg}
                                src={assetUrl + 'img/miky/sitting-miky.png'}
                                width={avatarSize}
                                height={avatarSize}
                            />
                            <Link to={ESHOP_URL}>
                                <span className={styles.EshopProductWidget__containerspan}>
                                    <div className={cx(
                                            styles.EshopProductWidget__containerdiv,
                                            styles.EshopProductWidget__profileName,
                                         )}
                                    >
                                        {headerText}

                                    </div>
                                    {!small &&
                                        <div className={cx(
                                                styles.EshopProductWidget__containerdiv,
                                                styles.EshopProductWidget__eshop,
                                             )}
                                        >
                                            {getDomain(ESHOP_URL)}
                                        </div>
                                    }
                                </span>
                            </Link>
                        </div>
                        {small &&
                            <div className={styles.EshopProductWidget__line}/>
                        }
                    </>
                }
                <div className={styles[`EshopProductWidget__products${style}`]}>
                    {eshopProducts.map((eshopProduct, index) => {
                        return (
                            <React.Fragment key={index}>
                                <EshopProduct
                                    eshopProduct={eshopProduct}
                                    eshopProductPosition={index}
                                    widgetPosition={widgetPosition}
                                    slot={slot}
                                    pageId={pageId}
                                    key={index}
                                    small={small}
                                    style={style}
                                    index={index}
                                />
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        );
    }
}

interface EshopProductProps {
    eshopProduct: EshopProductEntity;
    eshopProductPosition: number;
    widgetPosition: number;
    slot: EshopProductWidgetSlot;
    pageId: number;
    small: boolean;
    style: string;
    index: number;
}

const EshopProduct: React.FunctionComponent<EshopProductProps> = ({
    eshopProduct,
    eshopProductPosition,
    pageId,
    slot,
    widgetPosition,
    small,
    index,
}) => {

    if (eshopProduct === undefined) {
        return <></>;
    }

    const imageUrl = eshopProduct.media?.url;

    const eshopProductName = eshopProduct.name !== null
        ? eshopProduct.name
        : '';

    const isPampers = eshopProduct.categoryId === 'Q2F0ZWdvcnk6ODY=' || eshopProduct.ancestorId === 'Q2F0ZWdvcnk6ODY=';

    const catid = eshopProduct.categoryId === 'Q2F0ZWdvcnk6ODY=' || eshopProduct.ancestorId === 'Q2F0ZWdvcnk6ODY='
        ? 'Q2F0ZWdvcnk6ODY='
        : eshopProduct.categoryId;

    const priceAndCurrency = isPampers
        ? ''
        : moneyPretty(eshopProduct.price, true, true, true);

    if (small) {

        const boxStyle =  index === 1
            ? cx(styles.EshopProduct__boxsmall, styles.EshopProduct__boxAlignItems, styles.EshopProduct__borderNone)
            : cx(styles.EshopProduct__boxsmall, styles.EshopProduct__boxAlignItems);
        return (
            <Link
                to={
                common_api_redirect_to_eshop_url(
                    eshopProduct.slug, {
                        epid: eshopProduct.idOriginal,
                        epos: eshopProductPosition,
                        wpos: widgetPosition,
                        slot,
                        pid: pageId,
                        vid: eshopProduct.variantId,
                        catid,
                        utm_camp: eshopProduct.utmCampaign,
                    })}>
                <div className={boxStyle}>
                    <ImgCropped
                        className={styles.EshopProduct__containerImgDetailsmall}
                        width={50}
                        height={50}
                        mode={ImgCropMode.Embed}
                        imgWidth={256}
                        imgHeight={256}
                        imgUrl={imageUrl}
                    />
                    <div className={styles.EshopProduct__bodysmall}>
                        <Clamp clamp={2}>
                            <div>{eshopProductName}</div>
                        </Clamp>
                        {/*PC*/}
                        <div className={cx(styles.EshopProduct__bigScreen, styles.EshopProduct__priceStyle)}>
                            {priceAndCurrency}
                        </div>
                        {/*mobil*/}
                        <div className={cx(
                            styles.EshopProduct__buttonSmallMobile,
                            styles.EshopProduct__smallScreen,
                        )}>
                            <Link
                                to={
                                common_api_redirect_to_eshop_url(eshopProduct.slug, {
                                        epid: eshopProduct.idOriginal,
                                        epos: eshopProductPosition,
                                        wpos: widgetPosition,
                                        slot,
                                        pid: pageId,
                                        vid: eshopProduct.variantId,
                                        catid,
                                        utm_camp: eshopProduct.utmCampaign,
                                    })
                            }>
                                {BUY_IN_MK_ESHOP}
                            </Link>
                        </div>
                    </div>
                     {/*PC*/}
                     <div className={cx(
                         styles.EshopProduct__button,
                         styles.EshopProduct__bigScreen,
                     )}>
                         <object>
                            <Btn
                                asAnchor
                                sidePadding={BtnSidePadding.None}
                                type={BtnType.Link}
                                label={BUY_IN_MK_ESHOP}
                                link={common_api_redirect_to_eshop_url(eshopProduct.slug, {
                                    epid: eshopProduct.idOriginal,
                                    epos: eshopProductPosition,
                                    wpos: widgetPosition,
                                    slot,
                                    pid: pageId,
                                    vid: eshopProduct.variantId,
                                    catid,
                                    utm_camp: eshopProduct.utmCampaign,
                                })}
                            />
                         </object>
                     </div>
                     {/*mobil*/}
                     <div className={
                         cx(
                             styles.EshopProduct__priceStyle,
                             styles.EshopProduct__priceStyleMobile,
                             styles.EshopProduct__smallScreen)}>
                         {priceAndCurrency}
                     </div>
                </div>
            </Link>
        );
    } else {

        const boxStyleBig = index === 2
          ? cx(styles.EshopProduct__boxbig, styles.EshopProduct__bigScreen)
          : (index === 0
            ? cx(styles.EshopProduct__boxbig, styles.EshopProduct__marginNone, styles.EshopProduct__borderNone)
            : styles.EshopProduct__boxbig);

        return (
            <div className={boxStyleBig}>
                <Link to={
                    common_api_redirect_to_eshop_url(
                        eshopProduct.slug, {
                            epid: eshopProduct.idOriginal,
                            epos: eshopProductPosition,
                            wpos: widgetPosition,
                            slot,
                            pid: pageId,
                            vid: eshopProduct.variantId,
                            catid,
                            utm_camp: eshopProduct.utmCampaign,
                        })
                }
                      className={styles.EshopProduct__linkaligment}
                >
                    <div className={styles.EshopProduct__containerbig}>
                        <div className={styles.EshopProduct__containerImgbig}>
                            <ImgCropped
                                className={styles.EshopProduct__containerImgDetailbig}
                                width={185}
                                height={185}
                                mode={ImgCropMode.Embed}
                                imgWidth={256}
                                imgHeight={256}
                                imgUrl={imageUrl}
                            />
                        </div>
                            <div className={styles.EshopProduct__bodybig}>
                                <div className={styles.EshopProduct__bodyline}>
                                    <Clamp clamp={2}>
                                        <div>{eshopProductName}</div>
                                    </Clamp>
                                </div>
                                <div className={cx(styles.EshopProduct__priceStyle, styles.EshopProduct__marginTop)}>
                                    {priceAndCurrency}
                                </div>
                            </div>
                            <div className={cx(styles.EshopProduct__buttonMargin)}>
                                <div className={styles.EshopProduct__button}>
                                    <Link
                                        to={common_api_redirect_to_eshop_url(eshopProduct.slug, {
                                                epid: eshopProduct.idOriginal,
                                                epos: eshopProductPosition,
                                                wpos: widgetPosition,
                                                slot,
                                                pid: pageId,
                                                vid: eshopProduct.variantId,
                                                catid,
                                                utm_camp: eshopProduct.utmCampaign,
                                            })
                                    }>
                                        {BUY_IN_ESHOP}<br/>{IN_MK_ESHOP}
                                    </Link>
                                </div>

                            </div>
                    </div>
                </Link>
            </div>
        );
    }
};
